export default "__VITE_ASSET__1uoXK$V6__"